import { render, staticRenderFns } from "./TestingCenterPage.vue?vue&type=template&id=0138c528&"
import script from "./TestingCenterPage.vue?vue&type=script&lang=ts&"
export * from "./TestingCenterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports